import request from '@/auth/jwt/request'

/**
 * @description 业务分类 -- 业务分类列表
 * @param {Object} param params {Object} 传值参数
 */
export const zixunCateListApi = params => { return request('website-zixun-category/list', 'get', params) }

/**
 * @description 业务分类 -- 增加修改业务分类
 * id = 0 新增
 * @param {Object} param params {Object} 传值参数
 */
export const zixunCateSaveApi = data => { return request('website-zixun-category/save', 'post', {}, data) }

/**
 * @description 业务分类 -- 业务分类状态管理
 * @param {Object} param params {Object} 传值参数
 */
export const zixunCateStatusApi = params => { return request('website-zixun-category/status', 'get', params) }

/**
 * @description 业务分类 -- 业务分类详情
 * @param {Object} param params {Object} 传值参数
 */
export const zixunCateInfoApi = params => { return request('website-zixun-category/info', 'get', params) }
/**
 * @description 业务分类 -- 删除业务分类
 * { id = x }
 */
export const zixunCateDeleteApi = data => { return request('website-zixun-category/delete', 'delete', data) }